import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { RequestInProgressGuard } from "../../guards/request-in-progress/request-in-progress.guard";
import { SessionGuard } from "../../guards/session/session.guard";
import { MainRoutes } from "./../../guards/guard.models";
import { MainRequestsListComponent } from "./../../shared/main-requests-list/main-requests-list.component";
import { BOPUCNewRequestComponent } from "./new-request/new-request.component";

const buildingOrPartUseChangeRoutes: Routes = [
  {
    path: MainRoutes.BuildingOrPartUseChange,
    canActivate: [SessionGuard],
    children: [
      {
        path: "",
        redirectTo: "new-request",
        pathMatch: "full",
      },
      {
        path: "new-request",
        component: BOPUCNewRequestComponent,
        canDeactivate: [RequestInProgressGuard],
      },
      {
        path: "requests-list",
        component: MainRequestsListComponent,
      },
      {
        path: "**",
        redirectTo: "new-request",
        pathMatch: "full",
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(buildingOrPartUseChangeRoutes)],
  providers: [SessionGuard, RequestInProgressGuard],
  exports: [RouterModule],
})
export class BuildingOrPartUseChangeRoutingModule {}
